<template>
    <div
        class="CCardBox break-words"
        :class="{
            'rounded-md bg-white dark:bg-black shadow-card-box dark:shadow-gray-800': !plain,
            'p-4 sm:p-6': variant === 'default',
            'p-0': variant === 'nopadding',
            'p-4': variant === 'slim',
            'px-4 py-2': variant === 'slimHeight',
            'bg-gray-200 dark:bg-surface-card p-4 shadow-none sm:p-6': variant === 'flat'
        }"
    >
        <slot />
    </div>
</template>

<script setup lang="ts">
type Variant = 'default' | 'flat' | 'nopadding' | 'slim' | 'slimHeight'

withDefaults(
    defineProps<{
        variant?: Variant
        plain?: boolean
    }>(),
    {
        variant: 'default'
    }
)
</script>

<style lang="postcss" scoped>
.CCardBox > *:last-child {
    margin-bottom: 0;
}
</style>
